import axios from 'axios';
import store from '../store';

const axInst = axios.create({
  // baseURL: 'https://ctm.test.renxuncn.com', // url = base url + request url
  baseURL: 'https://api2.renxuncn.com/ctm/',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    // Authorization: sessionStorage.getItem('token')
  },
  transformRequest: [
    data => {
      // 对 data 进行任意转换处理
      var str = '';
      for (var key in data) {
        str += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&';
      }
      return str.slice(0, str.length - 1);
    }
  ],
  timeout: 60 * 1000
});

// 添加请求拦截器
axInst.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    config.url = `/rest` + config.url;
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
axInst.interceptors.response.use(
  response => {
    if (
      response.data.code &&
      (response.data.code == 4003 || response.data.code == 4001 || response.data.code == 4002)
    ) {
      store.commit('app/SET_LOGIN_VISIBLE', true);
    }
    // 对响应数据做点什么
    return response.data;
  },
  error => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

axInst.postJSON = (url, data) => {
  return axInst.post(url, data, {
    transformRequest: [
      data => {
        data = JSON.stringify(data);
        return data;
      }
    ],
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * 上传文件
 * 上传文件到文件服务器 -- 单文件key为upload 多文件key为files 其余功能自定义
 * @param url
 * @param formData
 * @returns {*}
 */
axInst.postFile = (url, formData) => {
  return axInst.post(url, formData, {
    //这里需要重写，直接返回formData，因为默认实例中改变了formData传输形式
    transformRequest: [
      data => {
        return data;
      }
    ],
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

// 将serves抛出去
export default axInst;
